import abcjs from "abcjs";
import { cleanAbc, magnetAbc, countMeasures } from "./abcUtils";

// Zoom stops — non-linear on purpose: fine control around 100% where the page fill
// flips between one and two pages, coarser at the extremes.
export const ZOOM_STOPS = [
  50, 60, 70, 80, 85, 90, 93, 96, 100, 104, 108, 112, 116, 120, 125, 130, 135, 140, 145, 150, 160, 170, 185, 200,
];

const NO_PAD = { paddingtop: 0, paddingbottom: 0, paddingleft: 0, paddingright: 0 };

// Render a tune into `el` at a zoom and paginate it into pages of `pageH`
// (the same "magnet" layout as the PDF export: rows snap onto the tune's own line breaks).
export const layoutAbc = (el, abc, contentW, pageH, zoomVal) => {
  const s = zoomVal / 100;
  const source = cleanAbc(abc);
  // pass 1 — how many measures fit a full-width row at 100%? (zoom-independent)
  abcjs.renderAbc(el, source, {
    staffwidth: contentW,
    scale: 1,
    oneSvgPerLine: true,
    wrap: { minSpacing: 1.8, maxSpacing: 5, lastLineFull: true },
    ...NO_PAD,
  });
  const baseRows = el.querySelectorAll("svg").length || 1;
  const capacity = Math.max(1, Math.round(countMeasures(source) / baseRows / s));
  // pass 2 — snap the rows onto the tune's own line breaks (magnet, ±1 measure)
  abcjs.renderAbc(el, magnetAbc(source, capacity, 1), { staffwidth: contentW / s, scale: 1, oneSvgPerLine: true, ...NO_PAD });
  const svgs = Array.from(el.querySelectorAll("svg"));

  // paginate greedily; a line never splits across pages
  const built = [];
  let cur = { lines: [] };
  let y = 0;
  svgs.forEach((svg) => {
    const h = (parseFloat(svg.getAttribute("height")) || svg.getBoundingClientRect().height || 60) * s;
    if (y + h > pageH && cur.lines.length > 0) {
      built.push(cur);
      cur = { lines: [] };
      y = 0;
    }
    cur.lines.push({ html: svg.outerHTML, h, s });
    y += h;
  });
  if (cur.lines.length > 0) built.push(cur);
  return { svgs, built };
};
